import { useMemo } from 'react';

type useCurrentGroupInfoProps = {
  groups: TCategories;
  currentPart: string;
};

export const useCurrentGroupInfo = ({
  groups,
  currentPart,
}: useCurrentGroupInfoProps) => {
  return useMemo(
    () =>
      currentPart
        ? groups.reduce((final, { parts: partsObject, ...category }) => {
            if (final) return final;

            const part = Object.values(partsObject).reduce(
              (final, partArray) => {
                return (
                  final ||
                  partArray.find((part) => {
                    return part.slug === currentPart;
                  })
                );
              },
              null
            );

            return part
              ? {
                  category: category,
                  part,
                }
              : null;
          }, null)
        : null,
    [groups, currentPart]
  );
};
